import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { COMPLIANCE_DISCLAIMER } from "@/lib/compliance-copy";

export default function PublicFooter() {
  return (
    <footer className="border-t border-white/10 bg-black/40 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-6 items-start">
        <div className="text-white/70 text-sm">
          <div className="text-white font-semibold">Crystal HACCP</div>
          <div className="mt-1">
            A project by <span className="font-semibold text-crystal-orange">The Mikanao 1519 Hub</span>.
          </div>
          <div className="mt-1">
            Contact:{" "}
            <a href="mailto:info@crystalhaccp.com" className="underline hover:text-white">
              info@crystalhaccp.com
            </a>
          </div>
          <div className="mt-2 flex gap-4 text-white/70">
            <a href="https://instagram.com/mikanao_1519" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-white">
              <Instagram size={16} />Instagram
            </a>
            <a href="https://facebook.com/mikanao1519" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-white">
              <Facebook size={16} />Facebook
            </a>
            <a href="https://x.com/Bigboysnoop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-white">
              <Twitter size={16} />X/Twitter
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 text-white/70 text-sm md:justify-items-end">
          <div className="space-y-2">
            <div className="text-white font-semibold">Product</div>
            <Link to="/platform" className="block hover:text-white">Platform</Link>
            <Link to="/regional-compliance" className="block hover:text-white">Regional Compliance</Link>
            <Link to="/multi-location" className="block hover:text-white">Multi-Location</Link>
            <Link to="/industries" className="block hover:text-white">Industries</Link>
            <Link to="/haccp-app" className="block hover:text-white">HACCP app</Link>
            <Link to="/audit-check" className="block hover:text-white">Free inspection check</Link>
            <Link to="/ik-mat" className="block hover:text-white">IK-mat (Norge)</Link>
            <Link to="/sfbb-alternative" className="block hover:text-white">SFBB alternative</Link>
            <Link to="/temperature-log" className="block hover:text-white">Temperature log</Link>
            <Link to="/pricing" className="block hover:text-white">Pricing</Link>
            <Link to="/download-app" className="block hover:text-white">Download App</Link>
          </div>
          <div className="space-y-2">
            <div className="text-white font-semibold">Company</div>
            <Link to="/resources" className="block hover:text-white">Resources</Link>
            <Link to="/blog" className="block hover:text-white">Food-safety blog</Link>
            <Link to="/privacy-policy" className="block hover:text-white">Privacy Policy</Link>
            <Link to="/terms-of-service" className="block hover:text-white">Terms of Service</Link>
            <Link to="/cookies" className="block hover:text-white">Cookies</Link>
            <Link to="/auth" className="block hover:text-white">Sign In</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <p className="text-white/50 text-xs leading-relaxed">{COMPLIANCE_DISCLAIMER}</p>
        </div>
      </div>
    </footer>
  );
}
